module.exports = window["wp"]["formatLibrary"];